import React from 'react';

import { Translation } from '../../common';

import styles from './index.module.scss';

export default ({ username }) => (
  <div>
    <div className={styles['sepa__wrapper']}>
      <Translation>SEPA_PAYMENT_PANEL_PAYMENT_TEXT</Translation>
      <div className={styles['sepa__content-table']}>
        <div className={styles['sepa__content-row']}>
          <div className={styles['sepa__content-cell_bold']}>IBAN</div>
          <Translation className={styles['sepa__content-cell']}>
            SEPA_PAYMENT_PANEL_IBAN
          </Translation>
        </div>
        <div className={styles['sepa__content-row']}>
          <div className={styles['sepa__content-cell_bold']}>BIC</div>
          <Translation className={styles['sepa__content-cell']}>
            SEPA_PAYMENT_PANEL_BIC
          </Translation>
        </div>
        <div className={styles['sepa__content-row']}>
          <Translation className={styles['sepa__content-cell_bold']}>
            SEPA_PAYMENT_PANEL_PURPOSE_TEXT
          </Translation>
          <div className={styles['sepa__content-cell']}>
            Aktenzeichen {username}
          </div>
        </div>
      </div>
      <Translation isHtml>SEPA_PAYMENT_PANEL_NOTE</Translation>
    </div>
  </div>
);
